import { convertObjectToArray } from "./convert_object_to_array";

const SYMBOL_TO_EXTRACT = "-";

const createModulesDTO = (data = {}) => {
  const array = [];
  const dataSumbit = {
    term: data.term,
    isOverride: data.isOverride,
  };

  convertObjectToArray(data.modules).forEach(([key, value]) => {
    const idx = key.indexOf(SYMBOL_TO_EXTRACT);

    const extract_position = Number(key.slice(idx + 1));

    const formatObject = {
      name: value.name,
      position: extract_position,
    };

    array.push(formatObject);
  });

  dataSumbit.modules = array;

  return dataSumbit;
};

const createModulesTestDTO = (data = {},courseListInput) => {
  const array = [];
  
  const dataSumbit = {
    courseList: courseListInput
  };

  convertObjectToArray(data.modules).forEach(([key, value]) => {
    const idx = key.indexOf(SYMBOL_TO_EXTRACT);

    const extract_position = Number(key.slice(idx + 1));

    const formatObject = {
      name: value.name,
      position: extract_position,
    };

    array.push(formatObject);
  });

  const subDataSumbit = {
    isOverride: data.isOverride,
    modules: array
  };

  dataSumbit.modulesInput = subDataSumbit;

  return dataSumbit;
};

export { createModulesDTO, createModulesTestDTO };
